<template>
  <div>
    <!-- <a-button
      type="primary"
      @click="toggleCollapsed"
      style="margin-bottom: 16px"
    >
    </a-button> -->
    <a-menu
      :openKeys="openKeys"
      v-model:selectedKeys="selectedKeys"
      @openChange="onOpenChange"
      mode="inline"
      theme="dark"
      :inline-collapsed="collapsed"
    >
      <template v-for="item in menus" :key="item.id">
        <template v-if="!item.children">
          <a-menu-item :key="item.id">
            <span>{{ item.describe }}</span>
          </a-menu-item>
        </template>
        <template v-else>
          <sub-menu :menu-info="item" :key="item.id" />
        </template>
      </template>
    </a-menu>
  </div>
</template>

<script>
import { Menu } from 'ant-design-vue'
import SubMenu from './SubMenu'
import { treeToList } from '@utils/utils'
import { mapActions } from 'vuex'

export default {
  components: {
    'sub-menu': SubMenu,
  },
  props: {
    theme: {
      type: String,
      default: 'dark',
    },
    menus: {
      type: Array,
    },
  },
  data() {
    return {
      collapsed: false,
      openKeys: [],
      selectedKeys: [],
    }
  },
  mounted() {},
  watch: {
    menus(n) {
      //   var list = [];
      //   treeToList(n, list);
      //   console.log(list);
    },
    ['$route.name'](n) {
      if (n == 'login') {
        return
      }
      var list = []
      treeToList([...this.menus], list)
      var menu = list.find((menu) => menu.name == n)
      this.selectedKeys = [menu?.id]
      this.openKeys = [menu?.parent_id]
      this.addRoute(menu)
    },
  },
  methods: {
    ...mapActions('route', ['addRoute']),
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      )
      //   if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      //     this.openKeys = openKeys;
      //   } else {
      this.openKeys = latestOpenKey ? [latestOpenKey] : []
      //   }
    },
  },
}
</script>
